import GuestServicesResponse, { MobilityOption, PreloadResponse, Service } from '@/models/services'

const getMobilityOptionTitle = (mobilityOptions: MobilityOption[], mobilityOptionId: string): string =>
  mobilityOptions.find((mobOption) => mobOption.id === mobilityOptionId)?.title

const reducePreloadResponse = (preload: (Service | MobilityOption)[], key: 'id' | 'serviceKey'): string =>
  preload.reduce((prev, curr) => [...prev, curr[key]], []).join(',')

function mapPreloadResponseToGuestServiceResponse(preload: PreloadResponse): GuestServicesResponse {
  return {
    ...preload,
    services: sortByDueServices(preload.services.services),
    mobilityOptions: preload.services.mobilityOptions,
  }
}

const sortByDueServices = (services: Service[]): Service[] => {
  return services?.sort((service) => (service.isServiceDue ? -1 : 1)) ?? []
}

const findDueServices = (services: Service[]): Service[] => {
  return services?.filter((service) => service.isServiceDue) ?? []
}

export {
  findDueServices,
  getMobilityOptionTitle,
  mapPreloadResponseToGuestServiceResponse,
  reducePreloadResponse,
  sortByDueServices,
}
